import httpClient from './httpClient';

const getPropertyLogs = () => httpClient.get('/api/v2/PropertyLog/GetPropertyLogs', { timeout: 180000 });
const addPropertyLog = (model) => httpClient.post('/api/v2/PropertyLog/AddPropertyLog', model);

const ex = {
  addPropertyLog,
  getPropertyLogs
}

export default ex;



// WEBPACK FOOTER //
// ./src/api/property-log-api.js